// Unit conversions and formatting helpers.
// Ported 1:1 from the original WordPress theme's strava-functions.js so the
// numbers shown on the site stay identical.

const METERS_PER_MILE = 1609.34;
const FEET_PER_METER = 3.28084;

/** Turn a number into a string with thousands separators. */
export function numberCommas(num) {
  return num.toLocaleString('en-US');
}

/** Format a decimal number of minutes as mm:ss. */
export function minTommss(minutes) {
  minutes = Math.round(minutes * 100) / 100;
  const sign = minutes < 0 ? '-' : '';
  const min = Math.floor(Math.abs(minutes));
  const sec = Math.floor((Math.abs(minutes) * 60) % 60);
  return sign + (min < 10 ? '0' : '') + min + ':' + (sec < 10 ? '0' : '') + sec;
}

/** Distance in miles (rounded to 2 decimals) from a Strava activity (meters). */
export function distanceMiles(activity) {
  return Math.round((activity.distance / METERS_PER_MILE) * 100) / 100;
}

/** Average pace as a mm:ss / mi string from a Strava activity (average_speed in m/s). */
export function pacePerMile(activity) {
  return minTommss(60 / ((activity.average_speed * 3600) / METERS_PER_MILE));
}

/** Total elevation gain in feet (with commas) from a Strava activity (meters). */
export function elevationFeet(activity) {
  return numberCommas(Math.round(activity.total_elevation_gain * FEET_PER_METER));
}

/** Direct link to the activity on Strava. */
export function stravaActivityUrl(activity) {
  return `https://www.strava.com/activities/${activity.id}`;
}
